import { compareDesc } from 'core/utils/date'

import { type SuggestedPreferredLane } from '../domain/SuggestedPreferredLane'
import { type SuggestedPreferredLaneRepository } from '../infra/SuggestedPreferredLaneRepository'

export type GetSuggestedPreferredLanes = () => Promise<Array<SuggestedPreferredLane>>

export type GetSuggestedPreferredLanesDependencies = {
  suggestedPreferredLaneRepository: SuggestedPreferredLaneRepository
}

export function getSuggestedPreferredLanesFactory({
  suggestedPreferredLaneRepository,
}: GetSuggestedPreferredLanesDependencies): GetSuggestedPreferredLanes {
  return async function getSuggestedPreferredLanes(): Promise<Array<SuggestedPreferredLane>> {
    try {
      const suggestions = await suggestedPreferredLaneRepository.getAll()
      const activeSuggestions = suggestions.filter(({ dismissed }) => !dismissed)

      activeSuggestions.sort((a, b) => {
        return compareDesc(a.suggestionDate, b.suggestionDate)
      })

      return activeSuggestions
    } catch (error) {
      throw new Error('Failed to get the list of Suggested Preferred Lanes', {
        cause: error as Error,
      })
    }
  }
}
